module.exports = __webpack_public_path__ + "static/media/BebasNeue-Regular.21bb70b6.ttf";